
export const formatTimeTo12Hour = (timeString) => {
    const [hours, minutes] = timeString?.split(':');
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);

    return date.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    });
}

